import { render, staticRenderFns } from "./SearchMessages.vue?vue&type=template&id=68380558"
import script from "./SearchMessages.vue?vue&type=script&lang=js"
export * from "./SearchMessages.vue?vue&type=script&lang=js"
import style0 from "./SearchMessages.vue?vue&type=style&index=0&id=68380558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports